import { data } from '../../svg/Info/data';
import { makeIcon } from '../makeIcon';

export const Info = makeIcon(data, 'info', 'Info');

export default Info;
